import React from 'react'
import Badge from 'react-bootstrap/Badge'
import { TimeRange } from '@interfaces/events'
import { parseDateString } from '@utils/strings'
import { onKeyActivate } from '@utils/onKeyActivate'
import { format, utcToZonedTime } from 'date-fns-tz'

const { I18n } = window
const contractTimeZone = window.__STOREFRONT__.timeZone

interface EventDateTimeChipProps {
  index: number
  timeRange: TimeRange
  onClick(): void
  contractTimeZone?: string
}

const formatTimeRangeChip = (e: TimeRange) => {
  const start = utcToZonedTime(parseDateString(e.start_at), contractTimeZone)
  const end = utcToZonedTime(parseDateString(e.end_at), contractTimeZone)
  const startDate = format(start, I18n.t('date.formats.chip'))
  const endDate = format(end, I18n.t('date.formats.chip'))
  const from = format(start, 'h:mm a')
  const to = format(end, 'h:mm a - zzz', {
    timeZone: contractTimeZone,
  })

  // Check if start and end dates are different
  if (startDate !== endDate) {
    return `${startDate} ${from} TO ${endDate} ${to}`
  } else {
    return `${startDate} - ${from} TO ${to}`
  }
}

const EventDateTimeChip: React.FC<EventDateTimeChipProps> = ({ index, timeRange, onClick }) => {
  if (timeRange._destroy) {
    return (
      <>
        <input
          type="hidden"
          value={timeRange.id}
          name={`program_event[time_ranges_attributes][${index}][id]`}
        />
        <input
          type="hidden"
          value="1"
          name={`program_event[time_ranges_attributes][${index}][_destroy]`}
        />
      </>
    )
  } else {
    return (
      <Badge key={index} variant="primary" className="p-3 m-2 chip">
        {formatTimeRangeChip(timeRange)}
        <span
          className="mdi mdi-window-close pl-2 white-text cursor-pointer"
          role="button"
          onClick={onClick}
          tabIndex={0}
          onKeyDown={onKeyActivate('click')}
          aria-label={I18n.t('views.events.delete_event_date')}></span>
        <input
          type="hidden"
          value={timeRange.id}
          name={`program_event[time_ranges_attributes][${index}][id]`}
        />
        <input
          type="hidden"
          value={timeRange.start_at}
          name={`program_event[time_ranges_attributes][${index}][start_at]`}
        />
        <input
          type="hidden"
          value={timeRange.end_at}
          name={`program_event[time_ranges_attributes][${index}][end_at]`}
        />
      </Badge>
    )
  }
}

export default EventDateTimeChip
